// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wYIy","comment":"styles_comment__duKSh"};